<script lang="ts" setup>
/**
 * AggreWeekly.vue
 * 時間別チャート本体
 * 
 * 親コンポーネント
 * @/components/parts/aggregation/AggreMain.vue
 */
// ==================================
// import
// ==================================
import { onMounted, ref } from 'vue'

import AxlWeeklyChart from '@/components/parts/aggregation/charts/weekly/AxlWeeklyChart.vue'
import NearMissWeeklyChart from '@/components/parts/aggregation/charts/weekly/NearMissWeeklyChart.vue'
import TrafficWeeklyChart from '@/components/parts/aggregation/charts/weekly/TrafficWeeklyChart.vue'

import { useAggregationFiltersStore } from '@/store/app'

import { DateTime } from 'luxon'

// ==================================
// interface
// ==================================
interface Props {
  toDate: DateTime;
}

// ==================================
// data
// ==================================
const filterStore = useAggregationFiltersStore()

const props = defineProps<Props>()

const weeklyLabel = ref<string[]>([])

// ==================================
// hook
// ==================================
onMounted(() => {
  // 日次データのグラフラベルを生成する
  weeklyLabel.value = setWeeklyChartLabel(props.toDate)
})

// ==================================
// method
// ==================================
/**
 * 日別チャート用のラベルを生成する
 * @param targetDate - 対象日
 * @returns ラベル文字列
 */
const setWeeklyChartLabel = (targetDate: DateTime): string[] => {
  let label: string[] = []
  const toDateString = '-' + targetDate.toFormat('MM/dd')
  let work = targetDate.set({
    hour: 0,
    minute: 0,
    second: 0
  })
  for (let i = 0; i < 12; i++) {
    const segment = i == 11 ? work.minus({ hour: 2 }).toFormat('yyyy/MM/dd') + toDateString + ' 00:00' : work.minus({ hour: 2 }).toFormat('HH:mm')
    label.unshift(segment)
  }
  return label
}
</script>
<template>
  <div class="aggre-weekly">
    <NearMissWeeklyChart
      v-if="filterStore.$state.mode.category === 1"
      :to-date="toDate"
      :label="weeklyLabel"
    />
    <TrafficWeeklyChart
      v-if="filterStore.$state.mode.category === 2"
      :to-date="toDate"
      :label="weeklyLabel"
    />
    <AxlWeeklyChart
      v-if="filterStore.$state.mode.category === 3"
      :to-date="toDate"
      :label="weeklyLabel"
    />
  </div>
</template>
<style lang="scss" scoped>
  .aggre-weekly {
    width: 100%;
    height: 40vh;
    border: 1px #eee solid;
    :deep(canvas) {
      height: 40vh;
    }
  }
</style>
